var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ResultUpdates'),(_vm.mobile)?_c('MobileResults'):_c('div',[(_vm.overviewMode)?_c('Overview'):(_vm.bibleMode)?_c('BibleResults'):_c('Results')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }